import React, { useEffect, useState } from "react";
import { DatabaseBackup, AlertTriangle, ShieldCheck, Clock } from "lucide-react";
import { api } from "../lib/api";

const ageText = (days) => {
  if (days === null || days === undefined) return "Hiç yedeğiniz yok";
  if (days <= 0) return "Son yedek: bugün";
  if (days === 1) return "Son yedek: dün";
  return `Son yedek: ${days} gün önce`;
};

const TONE = {
  green: {
    box: "border-emerald-400/40 bg-emerald-500/10 hover:bg-emerald-500/15 text-emerald-200",
    Icon: ShieldCheck,
  },
  yellow: {
    box: "border-yellow-400/40 bg-yellow-500/10 hover:bg-yellow-500/15 text-yellow-200",
    Icon: Clock,
  },
  red: {
    box: "border-red-400/50 bg-red-500/10 hover:bg-red-500/15 text-red-200",
    Icon: AlertTriangle,
  },
};

/** Otomatik yedek durumu — DÜRÜST üç hâl. Kullanıcı açmış ama sunucuda
 *  zamanlayıcı kapalıysa "OTO AÇIK" yazmayız, uyarı gösteririz. */
const autoStateOf = (h) => {
  if (!h.user_auto_on) {
    return { key: "off", label: "OTO KAPALI", cls: "",
             title: "Otomatik yedek kapalı. Açmak için yedekleme sayfasına gidin." };
  }
  if (h.scheduler_running === false) {
    return {
      key: "server-off",
      label: "OTO AÇIK — SUNUCUDA DEVRE DIŞI",
      cls: "text-amber-300 font-semibold",
      title: "Otomatik yedeği siz açtınız ancak sunucuda otomatik yedek zamanlayıcısı "
           + "kapalı olduğu için yedek ALINMIYOR. Sizin hatanız değil — yöneticinizin "
           + "sunucu ayarını açması gerekiyor.",
    };
  }
  return { key: "on", label: "OTO AÇIK · her gece 03:00", cls: "",
           title: "Otomatik yedek açık ve sunucuda çalışıyor." };
};

/** Sessiz, satır içi yedek sağlık kartı. Modal DEĞİL, hiçbir tıklamayı engellemez. */
export const BackupHealthCard = () => {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get("/my-backup/health")
      .then(({ data }) => alive && setHealth(data))
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!health) return null;
  const tone = TONE[health.status] || TONE.red;
  const { Icon } = tone;
  const autoState = autoStateOf(health);

  return (
    <button
      type="button"
      onClick={() => { window.location.href = "/yedekleme"; }}
      data-testid="backup-health-card"
      data-status={health.status}
      title="Yedekleme ve geri yükleme sayfasını aç"
      className={`w-full flex items-center gap-2 px-2.5 py-1.5 rounded border hud-text text-[11px] transition-colors ${tone.box}`}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" />
      <span className="truncate" data-testid="backup-health-text">
        {ageText(health.days_since)}
      </span>
      <span className="ml-auto flex items-center gap-1.5 opacity-80 shrink-0">
        <span data-testid="backup-health-count">{health.total_count} yedek</span>
        <DatabaseBackup className="h-3 w-3" />
        <span data-testid="backup-health-auto" data-auto-state={autoState.key}
              className={autoState.cls} title={autoState.title}>
          {autoState.label}
        </span>
      </span>
    </button>
  );
};

export default BackupHealthCard;
